import { App, Empty, Image, Modal, Spin, Tabs, Typography, Upload } from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import { useGenerations } from '@/hooks/useMedia';
import { uploadDocAttachment } from '@/api/flyerDocs';

interface Props { open: boolean; docId: string | null; onClose: () => void; onPick: (url: string) => void }

export function ImagePickerModal({ open, docId, onClose, onPick }: Props) {
  const { message } = App.useApp();
  const q = useGenerations({ modality: 'image', status: 'succeeded', pageSize: 36 });
  const items = q.data?.data ?? [];

  return (
    <Modal open={open} onCancel={onClose} footer={null} width={720} title="Pick an image">
      <Tabs items={[
        {
          key: 'upload', label: 'Upload',
          children: (
            <Upload.Dragger accept="image/*" showUploadList={false} disabled={!docId}
              customRequest={async ({ file, onSuccess, onError }) => {
                try {
                  const res = await uploadDocAttachment(docId!, file as File, 'element');
                  onSuccess?.({}); onPick(res.url); onClose();
                } catch (e) { onError?.(e as Error); message.error((e as Error).message); }
              }}>
              <p className="ant-upload-drag-icon"><InboxOutlined /></p>
              <p>Click or drag an image here</p>
            </Upload.Dragger>
          ),
        },
        {
          key: 'library', label: 'Media library',
          children: q.isLoading ? <Spin /> : items.length === 0 ? <Empty description="No generated images yet" /> : (
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(140px, 1fr))', gap: 8 }}>
              {items.map((g) => (
                <div key={g.id} style={{ cursor: 'pointer' }}
                  onClick={() => { if (g.results[0]) { onPick(g.results[0].url); onClose(); } }}>
                  {g.results[0] && <Image preview={false} src={g.results[0].url} height={110} style={{ objectFit: 'cover', borderRadius: 4, width: '100%' }} />}
                  <Typography.Paragraph ellipsis={{ rows: 1 }} style={{ fontSize: 11, margin: '4px 0 0' }}>{g.prompt}</Typography.Paragraph>
                </div>
              ))}
            </div>
          ),
        },
      ]} />
    </Modal>
  );
}
